<template>
<div style="min-height:100vh;position:relative;">
  <div class="contact-us">
    <NovoImg :src="usBg" :isPage="true"  type="cover" style="position:absolute;opacity:0.5;z-index:0;"/>
    <div :class="{'form-box':true,'filter-class':filterClassSwitch}"  style="z-index:10;">
      <p class="tip">为了提供更精确的服务，请简要描述您的需求（如购买产品或开放平台对接）</p>
       <Form ref="formData" :model="formData" :rules="ruleInline" label-position="left" :label-width="160">
          <div class="input-box">
            <FormItem prop="corporateName" label='您的公司名称'>
                <Input type="text" v-model="formData.corporateName" placeholder="" ></Input>
            </FormItem>
          </div>

          <div class="input-box">
            <FormItem prop="customerName" label='您的名字'>
                <Input type="text" v-model="formData.customerName" placeholder="" ></Input>
            </FormItem>
          </div>

          <div class="input-box">
            <FormItem prop="contactWay" label='您的联系方式'>
                <Input type="text" v-model="formData.contactWay" placeholder="邮箱地址或手机号" ></Input>
            </FormItem>
          </div>

          <div class="textarea-box">
            <FormItem label="简要需求">
              <Input v-model="formData.customerMessage" 
                type="textarea" 
                placeholder="简要需求能让我们为您提供更准确的服务，如购买产品或开放平台对接。"
              >
              </Input>
            </FormItem>
          </div>
          <div class="btn-box">
             <div class="btn" @click="handleSubmit('formData')">
              提交
            </div>
            <!-- <Button type="primary" @click="handleSubmit('formData')" long ref="submitBtn">登录</Button> -->
          </div>
          
           
        </Form>
    </div>
     <NovoGotop/>
      <Spin size="large" fix v-if="spinShow"></Spin>
      <NovoFooter style="    position: absolute;width: 100%;bottom: 0;"/>
      <div class="tip-box" v-show="showTipBox">
        <div class="tip-inner">
        </div>
          <div class="tip-box-inner">

            <div class="message-box">
              <img class="right-icon" :src="rightIcon" />
            </div>
            <div class="text-div">
              <div class="title-text">提交成功</div>
              <div class="detail-text">稍后会有专业人员与您联系~</div>
            </div>
          </div>
        

      </div>
    </div>
  </div>
</template>

<script>
  import rightIcon from 'common/image/contact-us/right-icon.png';
  import {NovoFooter,NovoGotop,NovoImg} from 'novo-ui';
import { setTimeout } from 'timers';
  
 

  export default {
    name: "ContactUs",
    components: {
      NovoFooter,
      NovoGotop,
      NovoImg
    },
    data() {
      return {
        rightIcon,
        showTipBox : false,
        usBg:require('common/image/user-classify/bg.png'),
        spinShow: false,
        inputStyle: "width:275px,height:44px",
        formData:{},
        timer : null,
        ruleInline: {
          corporateName: [
            {
              required: true,
              message: "请输入您的公司名称",
              trigger: "blur"
            }
          ],
          customerName: [
            {
              required: true,
              message: "请输入您的姓名",
              trigger: "blur"
            }
          ],
          contactWay: [
            {
              required: true,
              message: "请输入您的联系方式",
              trigger: "blur"
            }
          ]
        }

      };
    },
    mounted() {
     
    },
    computed: {
      filterClassSwitch:function(){
        return this.showTipBox;
      }
    },
    methods: {
   
      handleSubmit(name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            this.spinShow = true;
            this.submitContact();
          }
        });
      },
      submitContact(){
        let _this =this;
        let sendData = Object.assign({},this.formData);
        let rightIConImg = this.rightIcon;
        this.$http
        .post("contact-us", sendData)
        .then(function(response) {
          _this.spinShow = false;
          _this.formData = {};
          _this.showTipBoxFun();
        })
        .catch(function(err) {
          _this.spinShow = false;
          console.log("err",err);
        });
      },

      showTipBoxFun(){
        this.showTipBox = true;
        this.timer =setTimeout(()=>{
          this.showTipBox = false;
          this.timer = null;
        },2000)
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  // @import "~common/scss/variable";
  @import "~common/scss/mixin";
  .contact-us{
    width: 100%;
    min-height:100vh;
    padding-top:80px;
    padding-bottom: 287px;
    background: rgba(0,0,0,0.03);
    .filter-class{
      filter: blur(2px);
    }
    .form-box{
      width:476px;
      padding-top:8px;
      margin:0 auto;
      position: relative;
      .tip{
        font-family: DFPKingGothicGB-Light;
        font-size: 14px;
        color: #000000;
        text-align: center;
        line-height: 36px;
        margin-bottom:29px;
      }
      .ivu-form-label-left{
        .ivu-form-item-label{
          color : red;
        }
      }
      .ivu-form{
        .input-box{
          .ivu-form-item{
            .ivu-form-item-label{
                color:red;
                font-family: DFPKingGothicGB-Light;
                font-size: 14px;
                color: #000000;
                line-height: 36px;
              }
            } 
          }
        }
        .btn-box{
          text-align: center;
          margin-top: 20px;
          margin-bottom:20px; 
          @include button();
        }
   }
   .tip-box{
     z-index: 10;
     position: fixed;
     width: 100%;
     height: 100%;
     top: 0;
     left: 0;
     padding-top:80px;
     .tip-inner{
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.20);
      }
     .tip-box-inner{
       
      width: 360px;
      height: 120px;
      background: #fff;
      padding: 36px 0 0 56px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -60px 0 0 -180px;
      border-radius: 8px;
       .message-box{
         display: inline-block;
        .right-icon{
            width:44px;
            height: 44px;
          }
        }
     .text-div{
          display:inline-block;
          width:185px;
          margin-left: 16px;
          .title-text{
            font-family: PingFangSC-Regular;
            font-size: 18px;
            color: #353535;
            text-align: left;
          }
          .detail-text{
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #353535;
            text-align: left;
          }
        }
     }
   }
  }



</style>
<style lang="scss">
.contact-us{
  .ivu-spin{
    z-index : 10;
  } 
}
 .form-box{
   .input-box{
      .ivu-form-item{
        margin-bottom:33px;
            .ivu-form-item-label{
              font-family: DFPKingGothicGB-Light;
              font-size: 14px;
              color: #000000;
              line-height: 36px;
              padding:0;
            }
          }
          .ivu-form-item-content{
            height:38px;
            .ivu-input-wrapper{
              
              height:100%;
              background-image: linear-gradient(-135deg, #3CA9FF 0%, #7CE1FF 100%);
              border-radius: 5px;
              .ivu-input{
                height:36px;
                width:314px;
                margin:1px;
                font-size: 14px;
                border:none;
              }
            }
      }
   }
  
   .textarea-box{
     height: 200px;
     .ivu-form-item{
       height:100%;
       .ivu-form-item-label{
          font-family: DFPKingGothicGB-Light;
          font-size: 14px;
          color: #000000;
          line-height: 36px;
          padding:0;
        }
       .ivu-form-item-content{
         height:100%;
         .ivu-input-wrapper{
          background-image: linear-gradient(-135deg, #3CA9FF 0%, #7CE1FF 100%);
          border-radius: 5px;
         }
         textarea{
           width:314px;
           height: 200px;
           border: none;
           margin:1px;
         }
       }
     }
   }
   
  

 }
//  .ivu-message{
//   height: 100%;
  
  // .ivu-message-notice{
  //   height:100%;
  //   background:rgba(0,0,0,0.20);
  //   margin-top:50px;
  //   // filter: blur(2px);
  //   transform : all 0.5s;
  // }
//  }
//  .ivu-message-notice-content{
//    border-radius : 8px;
//    margin-top:56px;
//    .ivu-message-notice-content-text{
//      .ivu-message-success{
//       display: none;
//      }
     
//    }
   
//  }

</style>



// WEBPACK FOOTER //
// src/pages/contact-us/index.vue